export default __webpack_public_path__ + "static/media/south-valley.f52205b8.jpg";